import { Paper, Stack, Typography } from '@mui/material';

interface ISquareInfoProps {
  label: string;
  value: any;
}

export const SquareInfo = ({ label, value }: ISquareInfoProps) => {
  return (
    <Paper
      elevation={2}
      sx={{
        p: 3,
        minWidth: 140,
        minHeight: 120,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 2,
        backgroundColor: 'background.paper',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-2px)',
          boxShadow: 4,
        },
      }}
    >
      <Stack spacing={2} alignItems="center">
        <Typography
          variant="overline"
          color="text.secondary"
          fontWeight="bold"
          fontSize="0.85rem"
          letterSpacing={1}
        >
          {label}
        </Typography>
        <Typography
          variant={label === 'Paquetes' ? 'h4' : label === 'Ruta' ? 'h6' : 'h3'}
          color="primary"
          fontWeight="medium"
          align="center"
        >
          {value}
        </Typography>
      </Stack>
    </Paper>
  );
};
